import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { NavigationService } from '../services/navigation.service';

/*export class MenuItem {
  label: string;
  slug: string;
}

export class MenuParentItem {
  label: string;
  slug?: string;
  items?: MenuItem[];
}*/

@Component({
  selector: 'app-main-header',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss']
})
export class MainHeaderComponent implements OnDestroy {
  currentSection: string;
  sections: MenuItem[];
  isSideNavActive: boolean;
  shouldHide: boolean;
  searchText: string;

  private routerSubscription: Subscription;
  private SECTIONS_WHERE_TO_HIDE = ['online-games'];

  constructor(
    private router: Router,
    private navigationService: NavigationService
  ) {
    this.sections = [
      { label: 'Magazin', url: 'https://store.funbible.net/', target: '_blank', command: () => this.triggerHideNavigation() },
      { label: 'Unelte', routerLink: ['unelte'], command: () => this.triggerHideNavigation() },
      { label: 'Resurse', items: [
          { label: 'Activități', routerLink: ['activities'], command: () => this.triggerHideNavigation() },
          { label: 'Recenzii', routerLink: ['reviews'], command: () => this.triggerHideNavigation() },
          { label: 'Planșe de colorat', routerLink: ['coloring'], command: () => this.triggerHideNavigation() },
          { label: 'Cărți audio', routerLink: ['audio'], command: () => this.triggerHideNavigation() },
          { label: 'Desene animate', routerLink: ['cartoons'], command: () => this.triggerHideNavigation() },
          { label: 'Cântece', routerLink: ['songs'], command: () => this.triggerHideNavigation() },
          { label: 'Lucru manual', routerLink: ['crafts'], command: () => this.triggerHideNavigation() },
        ]
      },
      { label: 'Blog', routerLink: ['blog'] },
      { label: 'Despre', routerLink: ['about'], command: () => this.triggerHideNavigation() },
    ];

    this.routerSubscription = this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.currentSection = this.router.url.split('/')[1];
          this.shouldHide = this.SECTIONS_WHERE_TO_HIDE.includes(this.currentSection);
        }
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  triggerHideNavigation(): void {
    this.navigationService.hideSideMenu.next(true);
  }

  isSectionActive(section: string): boolean {
    return this.currentSection === section;
  }

  showSideNav(event) {
    this.isSideNavActive = true;
    event.preventDefault();
    event.stopPropagation();
  }
}
